import { useMenu } from '../menuController';

/**
 * Este aside aparece por defecto en los breakpoints
 * de desktop.
 */

export const Aside = () => {
  const children = useMenu([5, 6, 7]);
  return <>{children}</>;
};
